import openPortalApi from '../openPortalApi';
import API from '../portalApi';

const ENTITY = 'core';

export const getProposalContent = (proposalId) =>
    API.get(`/api/v1/${ENTITY}/contents/${proposalId}/`);

export const getRooftTypes = () =>
    openPortalApi.get(`/api/v1/${ENTITY}/roof-types/`);
